import React, { useState } from 'react';
import { Table, Card, Button, Input, Select, Space, message, Upload } from 'antd';
import { UploadOutlined, SaveOutlined, UndoOutlined, RedoOutlined } from '@ant-design/icons';
import * as XLSX from 'xlsx';
import { productApi } from '../services/api';

const { Option } = Select;

const ProductSize = () => {
  const [products, setProducts] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [unit, setUnit] = useState('cm');
  const [history, setHistory] = useState([]);
  const [historyIndex, setHistoryIndex] = useState(-1);

  const columns = [
    {
      title: '产品ID',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: '产品名称',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: '长度',
      dataIndex: 'length',
      key: 'length',
      render: (text, record) => (
        <Input
          value={text}
          onChange={(e) => handleSizeChange(record.id, 'length', e.target.value)}
          suffix={unit}
        />
      ),
    },
    {
      title: '宽度',
      dataIndex: 'width',
      key: 'width',
      render: (text, record) => (
        <Input
          value={text}
          onChange={(e) => handleSizeChange(record.id, 'width', e.target.value)}
          suffix={unit}
        />
      ),
    },
    {
      title: '高度',
      dataIndex: 'height',
      key: 'height',
      render: (text, record) => (
        <Input
          value={text}
          onChange={(e) => handleSizeChange(record.id, 'height', e.target.value)}
          suffix={unit}
        />
      ),
    },
  ];

  const handleSizeChange = (id, field, value) => {
    setProducts(products.map(item => 
      item.id === id ? { ...item, [field]: value } : item
    ));
  };

  const handleUnitChange = (value) => {
    setUnit(value);
    // 这里可以添加单位转换逻辑
  };

  const handleFileUpload = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const workbook = XLSX.read(e.target.result, { type: 'binary' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);
        
        // 保存当前状态到历史记录
        const newHistory = history.slice(0, historyIndex + 1);
        newHistory.push(products);
        setHistory(newHistory);
        setHistoryIndex(newHistory.length);
        
        setProducts(jsonData);
        message.success('数据导入成功');
      } catch (error) {
        message.error('文件解析失败');
      }
    };
    reader.onerror = () => {
      message.error('文件读取失败');
    };
    reader.readAsBinaryString(file);
    return false; // 阻止默认上传行为
  };

  const handleSave = () => {
    // 这里添加保存逻辑
    message.success('保存成功');
  };

  const handleUndo = () => {
    // 这里添加撤销逻辑
    message.info('撤销操作');
  };

  const handleRedo = () => {
    // 这里添加重做逻辑
    message.info('重做操作');
  };

  return (
    <div>
      <Card title="产品尺寸调整" style={{ marginBottom: 16 }}>
        <Space style={{ marginBottom: 16 }}>
          <Upload
                            accept=".xlsx,.xls,.xlsm"
            beforeUpload={handleFileUpload}
            showUploadList={false}
          >
            <Button icon={<UploadOutlined />}>导入Excel</Button>
          </Upload>
          <Select value={unit} onChange={handleUnitChange} style={{ width: 120 }}>
            <Option value="cm">厘米</Option>
            <Option value="inch">英寸</Option>
            <Option value="mm">毫米</Option>
          </Select>
          <Button icon={<UndoOutlined />} onClick={handleUndo}>撤销</Button>
          <Button icon={<RedoOutlined />} onClick={handleRedo}>重做</Button>
          <Button type="primary" icon={<SaveOutlined />} onClick={handleSave}>
            保存修改
          </Button>
        </Space>
        <Table
          columns={columns}
          dataSource={products}
          rowKey="id"
          rowSelection={{
            type: 'checkbox',
            onChange: (_, selectedRows) => setSelectedRows(selectedRows),
          }}
        />
      </Card>
    </div>
  );
};

export default ProductSize;

 